import React from "react";

import { RemoteComponentWrapper } from "./RemoteComponentWrapper";

const RemoteDynamicCartButton = React.lazy(
    () => import("adsMagnetoMfc/DynamicCartButton"),
) as React.FC<any>;

export const DynamicCartButton: React.FC<any> = (props) => {
    return (
        <RemoteComponentWrapper>
            <RemoteDynamicCartButton {...props} />
        </RemoteComponentWrapper>
    );
};
